module.exports = __webpack_public_path__ + "img/yw-logo.08c53f7c.png";